import { Exercise } from '../datamodels';

export type ExerciseTrackingMode = 'weight' | 'bodyweight' | 'assistance';

export const getExerciseTrackingMode = (
  machineTitle?: string,
  exercise?: Pick<Exercise, 'name' | 'tracking_mode'>
): ExerciseTrackingMode => {
  if (exercise?.tracking_mode) return exercise.tracking_mode;

  const value = `${machineTitle || ''} ${exercise?.name || ''}`.trim().toLocaleLowerCase();
  if (/assisted|dip\s*\/\s*chin machine/.test(value)) return 'assistance';
  if (/abdominal bench|45\s*(degree|°)|back extension|dipstation|dip station/.test(value)) return 'bodyweight';
  return 'weight';
};

export const trackingLabel = (mode: ExerciseTrackingMode) => {
  if (mode === 'bodyweight') return 'Additional load';
  if (mode === 'assistance') return 'Assistance';
  return 'Weight';
};
